<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('orders')">{{__('Orders')}}</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ data.organization.name }}  ({{data.contact.ref_no}} - {{data.order_no}})
    </h1>
    <trashed-message v-if="order.deleted_at && $page.props.auth.user.owner" class="mb-6" @restore="restore">
      This order has been deleted.
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-8xl " id="order-detail">

         <!-- grid veiw -->
        <div class="p-8 -mr-6 -mb-8  bg-white rounded-md shadow max-w-3xl gridView"  style="width:80%;">
            <div class="cards" style="float:left;"  v-if="data.order_detail.length > 0"
              v-for="order1 in data.order_detail" :key="order1.id"
             :style="{ backgroundImage:`url(/storageThumbnail/${order1.label.thumbnail_path})`, backgroundSize: `65% auto`, backgroundPositionY: `5px`}"> 
              <p style="background: white; padding: 5px;">
                <ul>
                  <li class="p-1">{{ order1.label.label_name }} </li> <li>({{ order1.label.price_per_1k }} €)</li>
                  <!-- <li class="p-1">{{data.organization.name}}</li> -->
                </ul>
              </p>
              <!-- <div class="bottom-bar">
                  <a style="display:contents" :href="'/storageFile/'+order1.label.file_path" target="_blank" title="View Label File" >
                    <icon name="view" class="block w-8 h-7 fill-indigo-400" />
                  </a>
              </div> -->
            </div>
        </div>

        <div class="p-8 -mr-6 -mb-8 max-w-4xl" style="margin-bottom:4rem;display:block;width:95%;">

          <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
              <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left"> {{__('Order')}} No </th>
                <td class="border-t px-6 pt-6 pb-4 "> {{data.contact.ref_no}} - {{data.order_no}} </td>
              </tr>
              <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left"> {{__('Invoice')}} No </th>
                <td class="border-t px-6 pt-6 pb-4 "> {{data.invoice_no}} </td>
              </tr>
              <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">{{__('Order')}} {{__('Total Cost')}}</th>
                <td class="border-t px-6 pt-6 pb-4 "> 
                  <span> {{data.total_cost}} € </span> 
                  <span style="  float: right;" v-if="data.status == 'Pending' && (!$page.props.auth.user.owner) && $page.props.auth.user.customer_id == 0">
                    <stripe-checkout
                        ref="checkoutRef"
                        :pk="publishableKey"
                        :sessionId="sessionId"
                    />
                    
                    <button class="btn-indigo"  @click="submit">{{__('Pay now!')}}</button>
                  </span>
                  
                </td>
              </tr>
              <!-- <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">{{__('Estimated')}} {{__('Delivery Date')}}</th>
                <td class="border-t px-6 pt-6 pb-4 font-bold"> {{data.delivery_date}} </td>
              </tr> -->
              <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">{{__('Invoice Address')}}</th>
                <td class="border-t px-6 pt-6 pb-4 "> 
                  {{data.contact.address}}, {{data.contact.city}}, {{data.contact.country}}, {{data.contact.postal_code}}  
                </td>
              </tr>
              <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">{{__('Customer')}} </th>
                <td class="border-t px-6 pt-6 pb-4 "> {{data.organization.name}} </td>
              </tr>

              <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">{{__('Contact')}}</th>
                <td class="border-t px-6 pt-6 pb-4 "> {{data.contact.first_name}} {{data.contact.last_name}} </td>
              </tr>
 
<!--          <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">{{__('Ref. No.')}}</th>
                <td class="border-t px-6 pt-6 pb-4 "> {{data.contact.ref_no}} </td>
              </tr> -->

              <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">{{__('Email')}}</th>
                <td class="border-t px-6 pt-6 pb-4 "> {{data.contact.email}} </td>
              </tr>

              <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">{{__('Phone')}}</th>
                <td class="border-t px-6 pt-6 pb-4 "> {{data.contact.phone}} </td>
              </tr>
              <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">{{__('Shipping Address')}}</th>
                <td class="border-t px-6 pt-6 pb-4 "> 
                  {{shipping_address.address}}, {{shipping_address.city}}, {{shipping_address.country}}, {{shipping_address.postal_code}}  
                </td>
              </tr>
              <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">{{__('Order Items')}}</th>
                <td class="border-t px-6 pt-6 pb-4 "> 
                  <p class="p-2" v-for="order2 in data.order_detail" :key="order2.id"> 
                    <span v-if="order2.label.ribbon">
                      {{getBoxes(1)}} ({{getExtraRibbons(order2.quantity)}} {{__('Ribbons')}})
                    </span>
                    <span v-else>
                      {{getBoxes(order2.quantity)}} - {{order2.quantity * order2.label.unit}} {{order2.label.label_name}} 
                     <!-- ({{order2.quantity*55000}} {{__('Labels')}} + {{order2.quantity*10}} {{__('Ribbons')}})  -->
                    </span>
                  </p>
                </td>
              </tr>
              <!-- <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">{{__('Order')}} {{__('Total')}} {{__('Quantity')}}</th>
                <td class="border-t px-6 pt-6 pb-4 "> 
                  {{getBoxes(data.quantity)}} 
                </td>
              </tr> -->

              <!-- <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">{{__('Order')}} {{__('Total Cost')}}</th>
                <td class="border-t px-6 pt-6 pb-4 "> {{data.total_cost}} € </td>
              </tr> -->

              <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">{{__('Order')}} {{__('Date')}}</th>
                <td class="border-t px-6 pt-6 pb-4 "> {{data.created_at}} </td>
              </tr>
            </table>
          </div>
          
        </div>

        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center" v-if="$page.props.auth.user.owner">
          <button v-if="!order.deleted_at && $page.props.auth.user.owner && false" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Order</button>
          <!-- <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update User</loading-button> -->
          <button v-if="!order.deleted_at && $page.props.auth.user.owner && false" class="text-indigo-600 hover:underline" tabindex="-1" type="button" @click="csv"> Create CSV</button>
          
        </div>
     
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Pdf from 'vue-pdf'
import arrayMap from 'lodash/_arrayMap'
import { StripeCheckout } from '@vue-stripe/vue-stripe'


export default {
  metaInfo() {
    return {
      title: `${this.data.id}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Pdf,
    Icon,
    StripeCheckout,
  },
  layout: Layout,
  props: {
    order: Object,
    shipping_address: Object,
    checkoutData: Object
    
  },
  remember: 'form',
  data() {
    return {
        data: this.order,
        extraRibbons: 0,
        labels: 0,
        ribbons: 0,
        tlabels: 0,
        tribbons: 0,
        publishableKey: (this.checkoutData?this.checkoutData.publishableKey:null),
        sessionId : (this.checkoutData?this.checkoutData.checkout.id:null),
    }
  },
  mounted(){
      // console.log(this.checkoutData)
  },
  created(){
 
  },
  filters: {
  	subStr: function(string) {
    	return string.substring(0,15) + '...';
        }
  },
  // watch: { 
  //   'data.order_detail': { 
  //       handler: function (after, before) {
  //               alert('here')
  //           },
  //           deep: true
  //   }
  // },
  methods: {
    submit(){
      this.$refs.checkoutRef.redirectToCheckout();
    },
    destroy() {
      if (confirm('Are you sure you want to delete this User?')) {
        this.$inertia.delete(this.route('orders.destroy', this.data.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this User?')) {
        this.$inertia.put(this.route('orders.restore', this.data.id))
      }
    },
    getExtraRibbons(quantity){
      this.extraRibbons = quantity*10
      return this.extraRibbons
    },
    async updateQuantity1(boxes){
       await this.getQuantityLabels1(boxes)
       return this.labels
      //  await this.getRibbons1(boxes)
    },
    updateQuantity(boxes){
          this.getQuantityLabels2(boxes).then((resp) => {
            alert(resp.data)
            return resp.data
          });
      //  await this.getRibbons1(boxes)
    },

    getQuantityLabels2(boxes){
       return new Promise(resolve => {
          // console.log('call labels1 = '+boxes)
          this.labels =  (parseInt(boxes)*55000)
          this.tlabels =  (parseInt(this.tlabels) + this.labels)
          return this.labels
       });
    },
     getQuantityLabels1(boxes){
          // console.log('call labels1 = '+boxes)
          this.labels =  (parseInt(boxes)*55000)
          this.tlabels =  (parseInt(this.tlabels) + this.labels)
          return this.labels
    },
    getRibbons1(boxes){
      // console.log('call ribbons1 = '+boxes)
      this.ribbons = (parseInt(boxes)*10)
      this.tribbons = parseInt(this.tribbons) + this.ribbons
      return this.ribbons
    },
    getBoxes(quantity){
       if(quantity == 1){
        return '1 stuk'
      }else{
        return quantity+' stuks'
      }
    },
    csv(){
      this.$inertia.get(this.route('orders.csv', this.data.id))
    }
  },
}
</script>
<style scoped>
 #order-detail{
    display:flex;
}
@media screen and (max-width: 720px) {
    #order-detail{
         display:block;
    }
}
.cards{
  width:215px;
  height:240px;
  background:#fff;
  margin:20px;
  border-radius:0.375rem;
  /* box-shadow:0px 0px 15px 0px #313131; */
  border: 1.5px solid #e2e8f0;
  background-size:102%;
  background-repeat:no-repeat;
  background-position:top center;
  position:relative;
  overflow:hidden;
}
.bottom-bar{
  width:100%;
  height:45px;
  position:absolute;
  bottom:-100%;
  background:#fff;
  transition:all 0.3s;
  text-align:center;
  display:flex;
  justify-content:center;
  align-items:center;
  z-index:99;
  border-top:1px solid #3333;
}
.cards:hover .bottom-bar{
  bottom:0px;
}
.cards a{
  cursor:pointer;
  padding:5px 10px;
  border-radius:4px;
  color:whitesmoke;
}
.cards a:hover{
  background:#3333;
  color:white;
}
.cards p{
  text-align:center;
  position:absolute;
  width:100%;
  bottom:5px;
  /* font-size:18px; */
  color:#39415a;
}
.gridView{
    display: flow-root;
    margin-bottom: 3%;
  }
/******************RESPONSIVE***********************/
@media screen and (max-width:500px){
  .gridView{
    display: grid;
    justify-content: center;
  }
  .cards{
    margin:15px 5px;
    width:215px;
    height:240px;
  }
  .bottom-bar{
    height:46px;
  }
}
</style>